import type { UserOnboardingState } from '@/models/onboarding/onboarding'

export const ONBOARDING_ROUTE = '/onboarding'

export type OnboardingGateState = Pick<
  UserOnboardingState,
  'onboarding_completed' | 'onboarding_skipped'
>

export function needsOnboarding(onboarding: OnboardingGateState | null | undefined): boolean {
  if (!onboarding) {
    return true
  }

  return !onboarding.onboarding_completed && !onboarding.onboarding_skipped
}

export function getOnboardingRedirectPath(
  onboarding: OnboardingGateState | null | undefined,
): string | null {
  return needsOnboarding(onboarding) ? ONBOARDING_ROUTE : null
}
